import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {useAuth0} from '@auth0/auth0-react';

import {AvatarWrapped} from '@pb/kit-component-avatar';
import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

import {selectCurrentUser} from '../services/user-info-slice';
import {getUserLabel} from '../utils';

const UserCornerView = () => {
    const {logout} = useAuth0();
    const currentUser = useSelector(selectCurrentUser);
    const caption = useMemo(() => (
        currentUser ? getUserLabel(currentUser) : ''
    ), [currentUser]);

    const handleLogout = async () => {
        try {
            window.localStorage.clear();
        } catch {
        }
        try {
            window.sessionStorage.clear();
        } catch {
        }
        await logout({logoutParams: {returnTo: window.location.origin}});
    };

    return (
        <>
            <DropdownMenu
                anchor={({positionRef, getAnchorProps, anchorRef}) => (
                    <div ref={anchorRef} {...getAnchorProps()} style={{cursor: 'pointer'}}>
                        <Group>
                            <AvatarWrapped
                                src={currentUser?.avatarUrl || ''}
                                alt={caption}
                                name={caption}
                                isCurrentUser={true}
                                placeholder={Icons.PERSON_ROUNDED}
                            />
                            <FlatButton endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}>
                                <b>{caption}</b>
                            </FlatButton>
                        </Group>
                    </div>
                )}>

                <DropdownMenuItem
                    iconBefore={Icons.LOG_OUT}
                    separated={true}
                    caption="Logout"
                    onClick={() => {
                        handleLogout();
                    }}
                />
            </DropdownMenu>

        </>
    );
};

export const UserCorner = () => {
    const {user} = useAuth0();


    if (!user) {
        return null;
    }

    return (
        <UserCornerView/>
    );
};
